const normalizeRoleName = (roleName) => {
  if (typeof roleName !== "string") {
    return "";
  }

  return roleName.trim().toLowerCase();
};

export const isEducatorRole = (roleName) => normalizeRoleName(roleName) === "educator";

export const canCustomizeJoinCodeExpiry = (roleName) =>
  ["admin", "creator"].includes(normalizeRoleName(roleName));

export { normalizeRoleName };
